import { translate } from '@lucidlink/uicore';
import { LUCIDLINK_CLASSIC_LINK_LOCATIONS } from '@lucidlink/workspacemanagement';
export const getLucidlinkClassicConfig = () => ({
    [LUCIDLINK_CLASSIC_LINK_LOCATIONS.LOGIN]: {
        title: translate('Looking to use our classic product?'),
        linkTo: 'https://www.lucidlink.com/webportal/login',
        linkText: translate('Log in to LucidLink Classic'),
        tooltipText: translate('If your account was created before November 7, 2024, it’s likely on LucidLink Classic, a separate platform from the new LucidLink. To access your account, log in through the LucidLink Classic portal.'),
    },
    [LUCIDLINK_CLASSIC_LINK_LOCATIONS.REGISTER]: {
        title: translate('Looking to use our classic product?'),
        linkTo: 'https://www.lucidlink.com/webportal/register',
        linkText: translate('Register in LucidLink Classic'),
    },
});
